import { Component, OnInit, ViewChild,HostBinding } from "@angular/core";
import { FieldConfig } from "../../field.interface";
@Component({
    selector: "app-espacio-en-blanco",
    template: `
    <div>
    </div>
`,
    styles: []
})
export class EspacioEnBlancoComponent implements OnInit {
    field: FieldConfig;
    @HostBinding('class') class = '';
    constructor() {
    }
    ngOnInit() {
      this.class = this.field.claseGrillaBootstrap;
    }
}
